
import { Vue, Component, Prop, Model } from "vue-property-decorator";
import { AmTabs } from "@afe/amui/src/components/Tabs";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmSpacing } from "@afe/amui/src/components/Spacing";
@Component({
  components: {
    AmTabs,
    AmTypography,
    AmSpacing
  }
})
export default class extends Vue {
  @Prop(String) readonly title!: string;
  @Prop(Array) readonly methods!: { label: string; value: any }[];
  @Prop(String) readonly value!: string;
  @Model("change") readonly model: any;
}
